import { extendObservable, runInAction } from 'mobx';

import { ProductsController } from '../../../networking/controllers/ProductsController';
import { Logger } from '../../../helpers/Logger';
import { ConfigParametersStore } from '../../../stores/ConfigParametersStore';

class CategoryProductsStoreClass {
  constructor() {
    extendObservable(this, {
      products: null,
    });
    this.subMenuId = null;
    this.productTypeId = null;
    // Used to avoid race conditions on products requests.
    this.productsRequestId = 0;
  }

  async fetchProductsForCategory(subMenuId, productTypeId, queryFilter) {
    this.productsRequestId += 1;
    const requestId = this.productsRequestId;
    try {
      if (this.products &&
        (this.subMenuId !== subMenuId || this.productTypeId !== productTypeId)) {
        runInAction(() => {
          this.products = null;
        });
      }
      const products = await ProductsController
        .findByCategory(subMenuId, productTypeId, queryFilter);
      if (requestId !== this.productsRequestId) {
        return;
      }
      runInAction(() => {
        this.products = products.map((product) => {
          const productPrice = ConfigParametersStore.isValueInFeatureFlagData('product-price', product.id);
          if (!product.shouldShowPrice() && productPrice) {
            // eslint-disable-next-line no-param-reassign
            product.financing = productPrice;
          }
          return product;
        });
      });
    } catch (error) {
      Logger.warn(error);
    }
  }
}

export const CategoryProductsStore = new CategoryProductsStoreClass();



// WEBPACK FOOTER //
// ./src/pages/product-index/stores/CategoryProductsStore.js